import * as yup from 'yup';

export const CreateScientificAreaFormValidation = yup.object().shape({
    description: yup.string().required('Descrição é obrigatória'),
});